import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useToast } from "@/hooks/use-toast";
import { Copy, RefreshCw } from "lucide-react";
import { useState } from "react";

const Settings = () => {
  const { toast } = useToast();
  const [copied, setCopied] = useState(false);
  const [apiKey] = useState("sk_test_your_api_key_here"); // In a real app, this would come from your backend

  const handleCopyApiKey = async () => {
    try {
      await navigator.clipboard.writeText(apiKey);
      setCopied(true);
      toast({
        title: "API key copied to clipboard",
      });
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast({
        variant: "destructive",
        title: "Failed to copy API key",
        description: "Please try again",
      });
    }
  };

  const handleRegenerateApiKey = () => {
    // In a real app, this would make a backend call to regenerate the API key
    toast({
      title: "API key regeneration",
      description: "This feature is not implemented yet",
    });
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <main className="flex-1 container py-6">
        <div className="max-w-4xl mx-auto space-y-6">
          <Card>
            <CardHeader>
              <CardTitle>API Keys</CardTitle>
              <CardDescription>
                Manage your API keys for accessing the application's services.
                Keep these keys secure and never share them publicly.
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
              <div className="space-y-4">
                <div className="relative flex-1">
                  <Input
                    type="password"
                    value={apiKey}
                    readOnly
                    className="pr-24"
                  />
                  <Button
                    variant="ghost"
                    size="sm"
                    className="absolute right-0 top-0 h-full px-3"
                    onClick={handleCopyApiKey}
                  >
                    <Copy className="h-4 w-4" />
                  </Button>
                </div>
                <Button
                  variant="outline"
                  onClick={handleRegenerateApiKey}
                  className="w-full sm:w-auto"
                >
                  <RefreshCw className="mr-2 h-4 w-4" />
                  Regenerate API Key
                </Button>
              </div>

              <div className="space-y-4">
                <h3 className="font-medium">API Documentation</h3>
                <div className="prose prose-sm max-w-none">
                  <p>
                    Use this API key to authenticate your requests to our API endpoints.
                    Include it in the Authorization header of your requests:
                  </p>
                  <pre className="bg-muted p-4 rounded-lg">
                    <code>
                      Authorization: Bearer YOUR_API_KEY
                    </code>
                  </pre>
                  <p>
                    For more information about our API endpoints and how to use them,
                    please refer to our API documentation.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </main>
    </div>
  );
};

export default Settings;